import { UserEmailTemplate } from './userEmailTemplate';

export class UserEmailTemplateForm {
    public id!: string;
    public userId!: string;
    public customerId?: string | null;
    public laboratoryEmailTemplateId!: string;
    public subject!: string;
    public currentEmailTemplates!: UserEmailTemplate[];
  }
